
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import logo from '../assets/images/logo.svg'




function Footer() {
    return (
        <>
            <footer className="main-footer footer-two bgs-cover text-white"
                style={{ backgroundImage: 'url(assets/images/footer/footer-bg-map.png)' }}>
                <div className="container">
                    <div className="footer-widget-area pt-85 pb-20">
                        <div className="row">
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer-widget about-widget">
                                    <div className="footer-logo mb-35">
                                        <a href="#"><img src={logo} alt="Logo" /></a>
                                    </div>
                                    <div className="text">
                                        Fueling Your Home with Safety, Reliability, and Convenience!
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer-widget link-widget ml-20 rml-0  align-content-center">
                                    <h4 className="footer-title text-center">Page Links</h4>
                                    <ul className="list-style-two d-flex flex-column align-content-center align-items-center">
                                        <li><a href="#">Home</a></li>
                                        <li><a href="#about">About</a></li>
                                        <li><a href="#services">Service</a></li>
                                        <li><a href="#gallery">Gallery</a></li>
                                        <li><a href="#contact">Contact</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer-widget newsletter-widget">
                                    <h4 className="footer-title">Contact</h4>
                                    <ul className="contact-info">
                                        <li>
                                        <i><FiPhoneCall /></i>
                                            <div className="content">
                                                <span>Call Us</span>
                                                <p><a href="tel:+9182486460134">+91-8248-646-013</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <i><MdOutlineEmail /></i>
                                            <div className="content">
                                                <span>Write to Us</span>
                                                <p><a href="mailto:maposithiru@gmail.com">maposithiru@gmail.com</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <i><SlLocationPin /></i>
                                            <div className="content">
                                                <span>Location</span>
                                                <p>17/2, SENIAMMAN KOIL STREET,<br />TONDIARPET,<br />CHENNAI - 600081</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright-area">
                    <div className="container">
                        <div className="copyright-inner pt-15">
                            <p>Copyright 2024 Rajeswari Maposi Indane Agency All Rights Reserved by <a
                                href="https://iconicglobalsolution.com/" className="copyright-hover" target="_blank" rel="noopener noreferrer">Iconic
                                Global Solution</a></p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;